import { useQuery } from 'react-query';
import axios from 'axios';
import { useSetRecoilState } from 'recoil';

import { apiConfig } from '@constants';
import { locationState } from '@store';

const fallbackLocation = {
  city: 'Atlanta',
  coords: {
    lat: 33.7491,
    lng: -84.3902,
  },
  state: 'GA',
  timeZone: 'America/New_York',
  market: 'none',
};

const getUserLocation = () =>
  axios.get(apiConfig.LOCAL_NOW_CITY_URL, {
    headers: {
      'X-API-KEY': apiConfig.LOCAL_NOW_API_KEY,
    },
  });

export const useSetLocation = () => {
  const setLocationState = useSetRecoilState(locationState);

  return useQuery('getUserLocation', () => getUserLocation(), {
    refetchOnWindowFocus: false,
    onSuccess: ({ data: { city } }) => {
      if (city?.geoPoint) {
        setLocationState({
          city: city.name,
          coords: {
            lat: city.geoPoint.latitude,
            lng: city.geoPoint.longitude,
          },
          state: city.stateCode,
          timeZone: city.timeZone,
          zipCode: city.zipCode,
          market: city.market,
        });
      } else {
        setLocationState(fallbackLocation);
      }
    },
    onError: error => {
      console.log({ error });
      setLocationState(fallbackLocation);
    },
  });
};
